// extracted by mini-css-extract-plugin
export default {"wrapper":"zopCzFIH","fadeIn":"vgWWGUDj","toolbar":"_hdJG0wm","title":"nc9265mc","subtitle":"XoH8E2US","newBtn":"KN04sDbG","newBtnIcon":"I3yX8y1f"};